module.exports = __webpack_public_path__ + "static/media/ba.80db369e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ba.svg
// module id = 2041
// module chunks = 0